import { get, post, del, put } from "../../utils/axiosInstance";

const BASE_URL = "/rest/inventory/production_session";

export const fetchSessions = (page, id = null, date = null, station = null) => {
  let url = `${BASE_URL}/?page=${page}`;
  if (id) url += `&id=${id}`;
  if (date) url += `&date_created=${date}`;
  if (station) url += `&station=${station}`;
  return get(url);
};

export const createSession = (data) => {
  const url = `${BASE_URL}/`;
  return post(url, data);
};

export const fetchSession = (sId) => {
  const url = `${BASE_URL}/${sId}/`;
  return get(url);
};

export const addIngredient = (psId, code, scan_format, times) => {
  const url = `${BASE_URL}/${psId}/ingredients/`;
  return post(url, { code: code, scan_format: scan_format, times: times });
};

export const deleteIngredient = (psId, info_id) => {
  const url = `${BASE_URL}/${psId}/ingredients/${info_id}/`;
  return del(url);
};

export const updateIngredient = (psId, info_id, amount) => {
  const url = `${BASE_URL}/${psId}/ingredients/${info_id}/`;
  return put(url, { amount: amount });
};

export const updateProdSession = (sId, data) => {
  const url = `${BASE_URL}/${sId}/`;
  return put(url, data);
};

export const fetchRecipes = (filter) => {
  const url = `/rest/inventory/recipes/`;
  return get(url, { params: { name: filter } });
};

export const createIntermediateLabels = (productionSessionId, data) => {
  const url = `${BASE_URL}/${productionSessionId}/intermediate_labels/`;
  return post(url, data);
};

export const finishSession = (sId, data = null) => {
  const url = `${BASE_URL}/${sId}/finish_session/`;
  return post(url, data);
};

export const fetchSessionOutput = (sId) => {
  const url = `${BASE_URL}/${sId}/production_output/`;
  return get(url);
};

export const fetchSessionDetail = (sId) => {
  const url = `${BASE_URL}/${sId}/production_detail/`;
  return get(url);
};

export const updateSession = (id, data) => {
  const url = `${BASE_URL}/${id}/update_session_items/`;
  return post(url, data);
};

export const fetchSessionCanProduce = (sId) => {
  const url = `${BASE_URL}/${sId}/get_can_produce/`;
  return get(url);
};

export const fetchStations = () => {
  const url = "/rest/inventory/station/";
  return get(url);
};

export const deleteProduct = (psId, info_id) => {
  const url = `${BASE_URL}/${psId}/products/${info_id}/`;
  return del(url);
};

export const addProduct = (psId, item_id, amount, pieces, times) => {
  const url = `${BASE_URL}/${psId}/products/`;
  return post(url, { item_id: item_id, amount: amount, pieces: pieces, times: times});
};

export const updateProduct = (psId, info_id, amount, pieces) => {
  const url = `${BASE_URL}/${psId}/products/${info_id}/`;
  return put(url, { amount: amount, pieces: pieces });
};

export const updateLeftover = (psId, info_id, hasLeftover, amount) => {
  const url = `${BASE_URL}/${psId}/leftovers/${info_id}/`;
  return put(url, { amount: amount, hasLeftover: hasLeftover });
};
